module.exports = __webpack_public_path__ + "static/media/generateCode.77b72a16.gif";